import { defineStore } from 'pinia'
import { threadsApi } from '@technologyadvice/relay-frontend'
import mentionGroupsApi from '@api/mentionGroups'

const byName = (first, second) => first.name.localeCompare(second.name)

export const useMentionGroupsStore = defineStore('mentionGroups', {
    state: () => ({
        mentionGroups: [],
        archivedGroups: [],
        mentionableUsers: [],
        isLoading: true,
        isSearchingUsers: false,
        error: false,
    }),
    actions: {
        async load() {
            this.$reset()

            try {
                const { data: { data } } = await mentionGroupsApi.getMentionGroups()

                this.mentionGroups = data
            } catch {
                this.error = true
            } finally {
                this.isLoading = false
            }
        },
        async fetchMentionGroup(uuid) {
            const { data: { data } } = await mentionGroupsApi.getMentionGroup(uuid)

            return data
        },
        async save(uuid, payload) {
            const { data: { data: saved } } = uuid
                ? await mentionGroupsApi.updateMentionGroup(uuid, payload)
                : await mentionGroupsApi.createMentionGroup(payload)

            this.mentionGroups = [ ...this.mentionGroups.filter(group => group.uuid !== saved.uuid), saved ]
                .sort(byName)

            return saved
        },
        async archive(uuid) {
            await mentionGroupsApi.archiveMentionGroup(uuid)

            this.mentionGroups = this.mentionGroups.filter(group => group.uuid !== uuid)
        },
        async loadArchived() {
            const { data: { data } } = await mentionGroupsApi.getArchivedMentionGroups()

            this.archivedGroups = data
        },
        async restore(uuid) {
            const { data: { data: restored } } = await mentionGroupsApi.restoreMentionGroup(uuid)

            this.archivedGroups = this.archivedGroups.filter(group => group.uuid !== uuid)
            this.mentionGroups = [ ...this.mentionGroups, restored ].sort(byName)
        },
        async searchMentionableUsers(search) {
            this.isSearchingUsers = true

            try {
                const { data: { data } } = await threadsApi.getMentionableUsers(search)

                this.mentionableUsers = data
            } finally {
                this.isSearchingUsers = false
            }
        },
    },
})
